import { useSelector } from 'react-redux'
import dynamic from 'next/dynamic'

import wrapper from 'redux/store'
import { redis } from 'utils/redis'
import { withRedis } from 'api/callConstructor'
import { getArticlesCall, getArticlesQACall } from 'api/calls'
import ArticlesPage from 'modules/learn/ArticlesPage/ArticlesPage'

const HeadTags = dynamic(() => import('components/app/HeadTags/HeadTags'))
// const ArticlesPage = dynamic(() => import('modules/learn/ArticlesPage/ArticlesPage'))

const ArticleContainer = props => {
  const { banners } = useSelector(({ app }) => app)

  const updatedProps = {
    ...props,
    banners
  }

  return (
    <>
      <HeadTags title="Articles" />
      <ArticlesPage {...updatedProps} />
    </>
  )
}

export const getStaticProps = wrapper.getStaticProps(async () => {
  const articlesPickFields =
    '&pick-fields=[*]slug&pick-fields=[*]title&pick-fields=[*]logo&pick-fields=[*]shortDescription&pick-fields=[*]published&pick-fields=[*]type&pick-fields=[*]tags'

  const articles = await withRedis(redis, getArticlesCall(articlesPickFields), `/learn/article`)

  const articlesQAPickFields =
    '&pick-fields=[*]slug&pick-fields=[*]title&pick-fields=[*]logo&pick-fields=[*]shortDescription&pick-fields=[*]published&pick-fields=[*]type&pick-fields=[*]image'

  const articlesQA = await withRedis(redis, getArticlesQACall(articlesQAPickFields), `/learn/article`)

  return {
    props: {
      articles: articles?.result || [],
      articlesQA: articlesQA?.result || []
    },
    revalidate: 600 // 10 min
  }
})

export default ArticleContainer
